module.exports = __webpack_public_path__ + "img/kinoliste.cdd2d325.png";